<template>
    <div>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Análisis de caracter</h4>
        </div>
        <card  v-for="category in categories_computed" :key="category.id" :id="'to'+category.id+'Element'" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title-orange">{{category.name}}</h6>
            </div>
            <div class="card-body">
                <ul class="list-group list-group-flush">
                    <li v-for="statement in category.statements" :key="statement.id" class="list-group-item d-flex justify-content-between align-items-center">
                        <p class="statement">{{statement.name}}</p>
                        <p class="switch">
                            <p-switch type="warning" v-model="statement.selected">
                                <i class="fa fa-check" slot="on"></i>
                                <i class="fa fa-times" slot="off"></i>
                            </p-switch>
                        </p>
                    </li>
                </ul>
                <br>
                <div class="row" style="margin: 0;">
                    <div class="col-xs-3">
                        <p style="color: white;">{{category.yes_value}}%</p>
                    </div>
                    <div class="col-xs-3 ml-auto">
                        <p style="color: white;">{{category.not_value}}%</p>
                    </div>
                </div>
                <p-progress
                    :values="[{type:'success', value:category.yes_value }, {type:'danger', value: category.not_value}]">
                </p-progress>
                
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <p-button @click="toCharacterAnalysisChart()" type="warning">Siguiente</p-button>
            <p-button @click="toBalance()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
        <fab
        :position="position"
        :bg-color="bgColor"
        :actions="fabActions"
        main-icon='search'
        icon-size="small"
        @to1="to1"
        @to2="to2"
        @to3="to3"
        @to4="to4"
        ></fab>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import fab from 'vue-fab'
    import VueScrollTo from 'vue-scrollto'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import CharacterAnalysis from 'src/util/CharacterAnalysis/CharacterAnalysis'
    import PProgress from 'src/components/UIComponents/Progress.vue'
    import moment from 'moment'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    // You can also pass in the default options
    Vue.use(VueScrollTo, {
            container: "body",
            duration: 500,
            easing: "ease",
            offset: 0,
            force: true,
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false,
            x: false,
            y: true
    })
    export default {
        components: {
            fab,
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            PProgress,
        },
        data() {
        return {
            microcredit: false,
            consumer: false,
            pyme: false,
            agro: false,
            categories: [],
            modelValidations: {
                statement : {
                    required: true
                }
            },
            bgColor: '#F09500',
            position: 'bottom-right',
            fabActions: [
                {
                    name: 'to1',
                    icon: 'E'
                },
                {
                    name: 'to2',
                    icon: 'H'
                },
                {
                    name: 'to3',
                    icon: 'RP'
                },
                {
                    name: 'to4',
                    icon: 'R'
                },
            ],
        }
        },
        watch: {

        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            categories_computed: {
                get () {
                    var sum = 0;
                    for (let i=0;i<this.categories.length;i++) {
                        for (let j=0;j<this.categories[i].statements.length;j++) {
                            if (this.categories[i].statements[j].selected) {
                                sum = sum + this.categories[i].statements[j].yes_percent;
                            }
                            else {

                                sum = sum + this.categories[i].statements[j].not_percent;
                            }
                        }
                        this.categories[i].yes_value = sum;
                        this.categories[i].not_value = 100 - sum;
                        sum = 0;
                    }
                    return this.categories;
                },
                set () {

                }
            },
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (product.name.toLowerCase() == 'consumo') {
                    this.consumer = true;
                    this.microcredit = false;
                    this.pyme = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                    this.microcredit = true;
                    this.consumer = false;
                    this.pyme = false;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.microcredit = false;
                    this.consumer = false;
                    this.pyme = true;
                    this.agro = false;
                }
                else if (product.name.toLowerCase() == 'agropecuario') {
                    this.microcredit = false;
                    this.consumer = false;
                    this.pyme = false;
                    this.agro = true;
                }
                else {
                    // this.showNotificationError('Este tipo de producto aún no es implementado en EMI');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            to1 () {
                VueScrollTo.scrollTo('#to1Element')
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            to2 () {
                VueScrollTo.scrollTo('#to2Element')
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            to3 () {
                VueScrollTo.scrollTo('#to3Element')
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            to4 () {
                VueScrollTo.scrollTo('#to4Element')
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toBalance () {
                if (this.microcredit || this.pyme || this.agro) {
                    this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
                else if (this.consumer) {
                    this.$router.push('/asessments/new_asessment/customer/others/consumer_additional_information');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toCharacterAnalysisChart () {
                var vm = this;
                vm.$store.dispatch('setCharacterAnalysis', this.categories).then(()=>{
                    var payload = {
                        stage: 'Análisis de caracter',
                        description: 'Se responde el formulario de análisis de caracter.',
                        dateTime: moment().format()
                    };
                    this.$store.dispatch('setChangeLog', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/others/character_analysis_chart');
                    });
                });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveReferences () {
                if (this.products.length != 0) {
                    this.$store.dispatch('setReferences', this.products).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                    });
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].characterAnalysis.length != 0) {
                    this.categories = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].characterAnalysis;
                }
                else {
                    this.categories = [];
                    for (let i=0;i<this.$store.getters.getMethodologicalPillars.length;i++) {
                        var statements = [];
                        for (let j=0;j<this.$store.getters.getMethodologicalPillars[i].pillars.length;j++) {
                            statements.push({
                                id: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.id,
                                name: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.statement,
                                yes_percent: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.yesPercent,
                                not_percent: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.notPercent,
                                selected: false
                            })
                        }
                        this.categories.push({
                            id: this.$store.getters.getMethodologicalPillars[i].id,
                            name: this.$store.getters.getMethodologicalPillars[i].name,
                            acronym: this.$store.getters.getMethodologicalPillars[i].acronym,
                            statements: statements,
                            yes_value: 0,
                            not_value: 0
                        })
                    }
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)
                    this.productValidator(product);
                }
            }
            else if(this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].characterAnalysis.length != 0) {
                    this.categories = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].characterAnalysis;
                }
                else {
                    this.categories = [];
                    for (let i=0;i<this.$store.getters.getMethodologicalPillars.length;i++) {
                        var statements = [];
                        for (let j=0;j<this.$store.getters.getMethodologicalPillars[i].pillars.length;j++) {
                            statements.push({
                                id: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.id,
                                name: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.statement,
                                yes_percent: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.yesPercent,
                                not_percent: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.notPercent,
                                selected: false
                            })
                        }
                        this.categories.push({
                            id: this.$store.getters.getMethodologicalPillars[i].id,
                            name: this.$store.getters.getMethodologicalPillars[i].name,
                            acronym: this.$store.getters.getMethodologicalPillars[i].acronym,
                            statements: statements,
                            yes_value: 0,
                            not_value: 0
                        })
                    }
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType)
                    this.productValidator(product);
                }
            }
            if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].characterAnalysis.length != 0) {
                    this.categories = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].characterAnalysis;
                }
                else {
                    this.categories = [];
                    for (let i=0;i<this.$store.getters.getMethodologicalPillars.length;i++) {
                        var statements = [];
                        for (let j=0;j<this.$store.getters.getMethodologicalPillars[i].pillars.length;j++) {
                            statements.push({
                                id: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.id,
                                name: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.statement,
                                yes_percent: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.yesPercent,
                                not_percent: this.$store.getters.getMethodologicalPillars[i].pillars[j].node.notPercent,
                                selected: false
                            })
                        }
                        this.categories.push({
                            id: this.$store.getters.getMethodologicalPillars[i].id,
                            name: this.$store.getters.getMethodologicalPillars[i].name,
                            acronym: this.$store.getters.getMethodologicalPillars[i].acronym,
                            statements: statements,
                            yes_value: 0,
                            not_value: 0
                        })
                    }
                }
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType)
                    this.productValidator(product);
                }
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .fab-main .material-icons{
        color: black !important;
        background-color: #F09500 !important;
    }
    .fab-list li .material-icons{
        color: black !important;
        font-family: "Helvetica Neue" !important;
        font-size: 12px !important;
    }
</style>
